module.exports = __webpack_public_path__ + "static/media/awfxex32_114.887e5b92.ico";